import React, { useEffect, useState } from "react"
import { Alert, CardTitle, Container } from "reactstrap"
import { useSelector } from "react-redux"
import KycProgressBar from "./kycProgressBar"
import toast from "react-hot-toast"
import AuthorisedSignatory from "./authorisedSignatory"
import KycAuthorityLetter from "./authorityLetter"
import { useNavigate, useParams } from "react-router-dom"
import LoaderComponent from "components/loader"
import { useLazyResolveQueryStepsOnboardedInvestorQuery } from "store/api/wealthpartnerapi/onboard.api"
import { useLazyGetOnboardedInvestorsKycDataQuery } from "store/api/wealthpartnerapi/onboardResolve.api"
import BusinessAdditionalDetails from "./businessAdditionalDetails"
import BankDetails from "./bankDetails"
import ResolveOnboardFinalStep from "./resolveOnboardFinalStep"
import PhoneVerification from "./phoneVerification"
import PANCard from "./PANCard"
import CaptureSelfie from "./captureSelfie"
import AgreementDetails from "./agreementDetails"

const ResolveKycForInvestor = () => {
  const { id } = useParams()
  const [currentStep, setCurrentStep] = useState("")
  const [kycData, setKycData] = useState(null)
  const [querySteps, setQuerySteps] = useState([])
  const navigate = useNavigate()
  const [getResult, { isFetching }] = useLazyGetOnboardedInvestorsKycDataQuery()
  const [getQuerySteps, { isFetching: isLoading }] =
    useLazyResolveQueryStepsOnboardedInvestorQuery()

  useEffect(() => {
    if (kycData) {
      if (kycData?.status !== "QUERY_RAISED") {
        navigate("/")
      }
    }
  }, [kycData])

  useEffect(() => {
    getQuerystpesResult()
    getKycData()
  }, [id])

  const getQuerystpesResult = async () => {
    try {
      const { success, message, data } = await getQuerySteps({ id }).unwrap()
      if (success) {
        setQuerySteps(data?.steps)
        setCurrentStep(data?.current_step)
      }
    } catch (error) {
      if (error.status === 404) {
        navigate("/investor-management")
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const getKycData = async () => {
    try {
      const { success, message, data } = await getResult({ id }).unwrap()
      if (success) {
        setKycData(data)
      }
    } catch (error) {
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const getCurrentStepMessage = () => {
    let step = currentStep
    if (currentStep === "BANK_DETAILS") {
      step = "BANK_VERIFICATION"
    }
    if (["GST_WAIVER", "GST_DETAILS"].includes(currentStep)) {
      step = "PAN_GST"
    }
    const item = querySteps?.find((item) => item.key === step)
    return item?.message
  }

  return (
    <>
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid pb-6">
            <div className="mb-5">
              <CardTitle className="mb-4 pt-4">
                Resolve KYC Query ({kycData?.name})
              </CardTitle>
              {querySteps && (
                <KycProgressBar
                  kycData={kycData}
                  querySteps={querySteps}
                  currentStep={currentStep}
                />
              )}
            </div>
            {isFetching || (isLoading && <LoaderComponent />)}
            {(!isFetching || !isLoading) && kycData && (
              <div
                className={`pb-md-5 ${
                  currentStep !== "FINAL_STEP" ? "container-wrapper" : ""
                }`}
              >
                {currentStep !== "FINAL_STEP" && (
                  <div className="mt-md-5">
                    <Alert color="danger">
                      <h6>Admin Query: </h6>
                      {getCurrentStepMessage()}
                    </Alert>
                  </div>
                )}
                {currentStep === "PHONE_VERIFICATION" && (
                  <PhoneVerification
                    kycData={kycData}
                    currentStep={currentStep}
                    querySteps={querySteps}
                  />
                )}
                {["BANK_VERIFICATION", "BANK_DETAILS"].includes(
                  currentStep
                ) && (
                  <BankDetails currentStep={currentStep} kycData={kycData} />
                )}
                {currentStep === "AGREEMENT_DETAILS" && (
                  <AgreementDetails
                    currentStep={currentStep}
                    kycData={kycData}
                  />
                )}
                {currentStep === "BUSINESS_ADDITIONAL_DETAILS" && (
                  <BusinessAdditionalDetails
                    kycData={kycData}
                    currentStep={currentStep}
                  />
                )}
                {["GST_WAIVER", "GST_DETAILS", "PAN_GST"].includes(
                  currentStep
                ) && <PANCard kycData={kycData} currentStep={currentStep} />}
                {["AUTHORISED_SIGNATORY"].includes(currentStep) && (
                  <AuthorisedSignatory
                    kycData={kycData}
                    currentStep={currentStep}
                    querySteps={querySteps}
                  />
                )}
                {currentStep === "PHOTO" && (
                  <CaptureSelfie
                    kycData={kycData}
                    currentStep={currentStep}
                    querySteps={querySteps}
                  />
                )}
                {currentStep === "AUTHORITY_LETTER" && (
                  <KycAuthorityLetter
                    kycData={kycData}
                    querySteps={querySteps}
                    currentStep={currentStep}
                  />
                )}
                {currentStep === "FINAL_STEP" && (
                  <ResolveOnboardFinalStep
                    kycData={kycData}
                    querySteps={querySteps}
                    currentStep={currentStep}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    </>
  )
}

export default ResolveKycForInvestor
